import { useState } from "react";
import { useConfig } from "../../../context/ConfigContext";

/* ---------------------------------------- */
/* Manual Entry tab                         */
/* ---------------------------------------- */

export default function RaffleManualEntry() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [strips, setStrips] = useState(1);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const { config } = useConfig();
  const apiBase = config.REACT_APP_RAFFLE_BASE_URL;
  const apiKey = config.REACT_APP_ADMIN_API_KEY;

  const handleStrips = async (e) => {
    if (e.target.value > 20) {
        setStrips(20)
    } else {
        setStrips(e.target.value)
    }
  }

  const handleManual = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      const res = await fetch(`${apiBase}/manual-entry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Api-Key": apiKey
        },
        body: JSON.stringify({
          name,
          email,
          strips: Number(strips)
        }), credentials: "include"
      });

      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.error || "Failed to create manual entry");

      setMessage(`Manual entry created. Tickets: ${data.entry.ticketNumbers.join(", ")}`);
      setName("");
      setEmail("");
      setStrips(1);
    } catch (err) {
      setMessage(err.message || "Failed to create manual entry");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="raffle-section" onSubmit={handleManual}>
      <div className="raffle-search-grid">
        <label>
          <span>Name</span>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <label>
          <span>Email</span>
          <input
            className="input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          <span>Strips</span>
          <input
            className="input"
            type="number"
            min="1"
            max="20"
            value={strips}
            onChange={(e) => handleStrips(e)}
          />
        </label>
      </div>

      <div className="actions">
        <button className="btn primary" disabled={saving}>
          {saving ? "Saving…" : "Create Manual Entry"}
        </button>
      </div>

      {message && <p className="muted small">{message}</p>}
    </form>
  );
}